import React, { useEffect, useState } from 'react';
import Topbar from '../components/Topbar';
import Leftbar from '../components/Leftbar';
import { Link } from 'react-router-dom';
import { displayError, displaySuccess, getCoupons, getNriProviders, getNriUsers, getPhyios, getReschedules } from '../Utils/utils';
import { toggleLoader } from '../actions/loader';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import config from '../config/config';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import TimePicker from 'react-time-picker';
import moment from 'moment';
import DatePicker from 'react-datepicker';

const RescheduleList = (props) => {
  const [users, setUsers] = useState([]);
  const [is_delete, setIsDelete] = useState('');
  const [temp_var_id, setTempVarId] = useState('');
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1)
  const [show, setShow] = useState(false);
  const [fromTime, setFromTime] = useState(moment(new Date()).format('HH:mm'));
  const [toTime, setToTime] = useState(moment(new Date()).format('HH:mm'));
  const handleClose = () => setShow(false);
  const [fromDate, setFromDate] = useState(new Date());

  const getList = async () => {
    props.toggleLoader(true);
    var getUsers_var = await getReschedules(count, page);
    setPage(getUsers_var?.metadata?.totalPage)
    console.log(getUsers_var)
    setUsers(getUsers_var.data);
    props.toggleLoader(false);
  }

  useEffect(() => {
    getList()
  }, [])

  const handlePageClick = async (e) => {
    props.toggleLoader(true);
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    const selectedPage = e.selected + 1;
    var getUsers_var = await getNriUsers(count, selectedPage);
    setPage(getUsers_var?.metadata?.totalPage)
    setUsers(getUsers_var.data);
    // setSkip(selectedPage * limit)
    // getList(search)

    props.toggleLoader(false);
  };


  const onSave = () => {

    let path = config.siteUrl;
    path = path + '/nri/update-reschedule-request';
    var token = localStorage.getItem('token');
    const data = {
      session_id: temp_var_id,
      fromTime: fromTime,
      toTime: toTime,
      date: moment(fromDate).format('YYYY-MM-DD')
    }
    axios.post(path, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }
    )
      .then(function (response) {
        props.toggleLoader(false);
        displaySuccess(response?.data?.message);
        setShow(false)
        getList()

      })
      .catch(function (error) {
        props.toggleLoader(false);
        displayError(error);
      })
    console.log(data)
  }


  return (
    <>
      <body class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar />
          <main className="main-content border-radius-lg">
            <Topbar />

            <div className="header bg-primary pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                          <li className="breadcrumb-item"><Link to="/dashboard-nri"><i className="fas fa-home" /></Link></li>
                          <li className="breadcrumb-item"><a href="#">Reschedule requests</a></li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="row">
                        <div className="col-9">
                          <h3 className="mb-0">Reschedule Requests </h3>
                        </div>
                        <div className="col-3">
                          {/* <h3 className="mb-0 display-end" >
                            <Link to={"/add-providers-nri"} >
                              <button className="btn btn-primary pull-right" style={{ marginRight: '5px' }}>Add Provider</button>
                            </Link></h3> */}
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Booking No.</th>
                            <th>Name</th>
                            <th>Provider</th>
                            <th>Reschdule reason</th>
                            <th>Slot</th>
                            <th>Preferred Slot</th>
                            <th>Session Status</th>
                            {/* <th>Languages</th> */}
                            {/* <th>Description</th> */}
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users?.map((user) => (
                            <tr>
                              <td className="table-user">
                                <b>{user.booking.booking_number} </b>
                              </td>
                              <td className="table-user">
                                <div style={{ width: '150px' }}>

                                  <b>{user.member?.name} </b>
                                  <div>{user.member?.phone_number} </div>
                                  <div>{user.member?.email} </div>
                                </div>
                              </td>

                              <td className="table-user">
                                <div style={{ width: '150px' }}>
                                  <b>{user.provider.name} </b>
                                  <div>{user.provider?.email} </div>

                                </div>
                              </td>
                              <td className="table-user">
                                <span>{user.reschedule_reason}  </span>
                              </td>
                              <td className="table-user">
                                <b>{user?.date} {user?.fromTime} - {user?.toTime} </b>
                              </td>
                              <td className="table-user">
                                <b>{user?.preferred_reschedule_time}  </b>
                              </td>

                              <td className="table-user">
                                <b style={{ textTransform: 'capitalize' }}>{user?.status} </b>
                              </td>

                              <td>
                                <button className="btn btn-primary pull-right" style={{ marginRight: '5px' }} onClick={() => {
                                  setTempVarId(user?._id)
                                  setShow(true)
                                }}>Reschedule</button>

                              </td>

                            </tr>
                          ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {users.length > 0 &&
                <Row>
                  {/* <Col xs={4}>
                    <div className='mb-1'>
                      <FormattedMessage id="Showing" /> {users?.length} <FormattedMessage id="accountants from page" /> {current_page} <FormattedMessage id="of" /> {pageCount}
                    </div>
                  </Col> */}
                  <Col xs={12}>
                    <div className='paginate-css'>
                      <ReactPaginate
                        previousLabel="<"
                        nextLabel=">"
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={page}
                        marginPagesDisplayed={0}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        // subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    </div>
                  </Col>
                </Row>}
              {/* {users && users.length > 0 &&
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                  {skip != 0 &&
                    <button className="btn btn-primary mr-4" onClick={(e) => {
                      setSkip(skip - limit)
                    }}> Prev </button>
                  }
                  {users.length != 0 && users?.length == limit &&
                    <button className="btn btn-primary pull-right" onClick={(e) => {
                      setSkip(skip + limit)
                    }} > Next </button>
                  }
                </div>
              } */}
            </div>
            <Modal show={show} onHide={() => setShow(!show)}>
              <Modal.Header closeButton>
                <Modal.Title>Reschedule Session</Modal.Title>
              </Modal.Header>
              <Modal.Body >
                <div className='row w-100 m-auto'>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label" >Date</label>

                      <DatePicker
                        selected={fromDate}
                        dateFormat="yyyy-MM-dd"
                        onChange={(date) => setFromDate(date)}
                        minDate={new Date()}
                        customInput={
                          <input
                            // style={{ width: '360px' }}
                            type="text"
                            className="form-control"
                            placeholder={('Date')}
                            value={fromDate}
                          />
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label" >From Time</label>
                      <TimePicker onChange={(e) => setFromTime(e)} value={fromTime}
                        format="HH:mm" // Set 24-hour format
                      // disableClock={true}
                      />

                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-control-label" >To Time</label>
                      <TimePicker onChange={(e) => setToTime(e)} value={toTime}
                        format="HH:mm" // Set 24-hour format
                      // disableClock={true}
                      />

                    </div>
                  </div>
                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>
                <Button variant="primary" onClick={onSave}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>

          </main>
        </div>
      </body>
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = (state) => {
  return {
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(RescheduleList);